import Assets from './Assets';

export default Assets;
